import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchModuleList = createAsyncThunk("fetchModuleList", async () => {
	const response = await axiosHttp.get(`module/list`);
	return response.data.data;
});

//action to create module
export const createModule = createAsyncThunk("createModule", async (body) => {
	const response = await axiosHttp.post(`module/create`, body);
	return response.data.data;
});

//action to update module
export const updateModule = createAsyncThunk("updateModule", async (body) => {
	const response = await axiosHttp.patch(`module/update/${body.module_id}`, body);
	return response.data.data;
});

const moduleListSlice = createSlice({
	name: "moduleList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		create: null,
		update: null,
	},

	reducers: {
		resetStateModuleList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
			state.create = null;
			state.update = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchModuleList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchModuleList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchModuleList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
		builder.addCase(createModule.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(createModule.fulfilled, (state, action) => {
			state.isLoading = false;
			state.create = action.payload;
		});
		builder.addCase(createModule.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
		builder.addCase(updateModule.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(updateModule.fulfilled, (state, action) => {
			state.isLoading = false;
			state.update = action.payload;
		});
		builder.addCase(updateModule.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStateModuleList } = moduleListSlice.actions;
export default moduleListSlice.reducer;
